'use strict';
/* eslint-env browser */

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _require = require('./error'),
    TimeoutError = _require.TimeoutError,
    AbortError = _require.AbortError;
/**
 * @typedef {RequestInit & ExtraFetchOptions} FetchOptions
 * @typedef {Object} ExtraFetchOptions
 * @property {number} [timeout]
 * @property {URLSearchParams} [searchParams]
 * @property {function({total:number, loaded:number, lengthComputable:boolean}):void} [onUploadProgress]
 * @property {function({total:number, loaded:number, lengthComputable:boolean}):void} [onDownloadProgress]
 * @property {string} [overrideMimeType]
 * @returns {Promise<Response>}
 */

/**
 * @param {string|URL} url
 * @param {FetchOptions} [options]
 * @returns {Promise<Response>}
 */


var fetch = function fetch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var request = new XMLHttpRequest();
  request.open(options.method || 'GET', url.toString(), true);
  var timeout = options.timeout;

  if (timeout > 0 && timeout < Infinity) {
    request.timeout = options.timeout;
  }

  if (options.overrideMimeType != null) {
    request.overrideMimeType(options.overrideMimeType);
  }

  if (options.headers) {
    var _iterator = _createForOfIteratorHelper(options.headers.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            name = _step$value[0],
            value = _step$value[1];

        request.setRequestHeader(name, value);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (options.signal) {
    options.signal.onabort = function () {
      return request.abort();
    };
  }

  if (options.onDownloadProgress) {
    request.onprogress = options.onDownloadProgress;
  }

  if (options.onUploadProgress) {
    request.upload.onprogress = options.onUploadProgress;
  }

  return new Promise(function (resolve, reject) {
    /**
     * @param {Event} event
     */
    var handleEvent = function handleEvent(event) {
      switch (event.type) {
        case 'error':
          {
            resolve(Response.error());
            break;
          }

        case 'load':
          {
            resolve(new ResponseWithURL(request.responseURL, request.response, {
              status: request.status,
              statusText: request.statusText,
              headers: parseHeaders(request.getAllResponseHeaders())
            }));
            break;
          }

        case 'timeout':
          {
            reject(new TimeoutError());
            break;
          }

        case 'abort':
          {
            reject(new AbortError());
            break;
          }

        default:
          {
            break;
          }
      }
    };

    request.onerror = handleEvent;
    request.onload = handleEvent;
    request.ontimeout = handleEvent;
    request.onabort = handleEvent;
    request.send(options.body);
  });
};

exports.fetch = fetch;
exports.Request = Request;
exports.Headers = Headers;
/**
 * @param {string} input
 * @returns {Headers}
 */

var parseHeaders = function parseHeaders(input) {
  var headers = new Headers();

  var _iterator2 = _createForOfIteratorHelper(input.trim().split(/[\r\n]+/)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var line = _step2.value;
      var index = line.indexOf(': ');

      if (index > 0) {
        headers.set(line.slice(0, index), line.slice(index + 1));
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return headers;
};

var ResponseWithURL = /*#__PURE__*/function (_Response) {
  _inherits(ResponseWithURL, _Response);

  var _super = _createSuper(ResponseWithURL);

  /**
   * @param {string} url
   * @param {string|Blob|ArrayBufferView|ArrayBuffer|FormData|ReadableStream<Uint8Array>} body
   * @param {ResponseInit} options
   */
  function ResponseWithURL(url, body, options) {
    var _this;

    _classCallCheck(this, ResponseWithURL);

    _this = _super.call(this, body, options);
    Object.defineProperty(_assertThisInitialized(_this), 'url', {
      value: url
    });
    return _this;
  }

  return ResponseWithURL;
}( /*#__PURE__*/_wrapNativeSuper(Response));